import type { MessageTableRowProps } from '@/types/predefined-messages';

export function areMessageTableRowPropsEqual(
  prev: Readonly<MessageTableRowProps>,
  next: Readonly<MessageTableRowProps>
): boolean {
  return (
    prev.filteredMessage === next.filteredMessage &&
    prev.categoryNames === next.categoryNames &&
    prev.recipients === next.recipients &&
    prev.rowRef === next.rowRef &&
    prev.dataIndex === next.dataIndex &&
    prev.onEdit === next.onEdit &&
    prev.onDelete === next.onDelete
  );
}
